<template>
    <el-menu
        :default-active="$route.path"
        :router="true"
        :collapse="collapsed"
        :collapse-transition="false"
        active-text-color="#AFD508"
        text-color="#656565"
        class="sider-menu"
    >
        <the-sider-menu-item
            v-for="menu in menus"
            :key="menu.path"
            :menu="menu"
        ></the-sider-menu-item>
    </el-menu>
</template>

<script>
import { asyncRoutes } from '@router/routes';
import { normalizeRoutes } from '@helpers/route';
import { cloneDeep } from 'lodash-es';
import TheSiderMenuItem from '@layouts/main/components/TheSiderMenuItem';

export default {
    name: 'TheSiderMenu',
    components: { TheSiderMenuItem },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            menus: []
        };
    },
    created() {
        this.getMenus();
    },
    methods: {
        getMenus() {
            this.menus = normalizeRoutes(cloneDeep(asyncRoutes));
        }
    }
};
</script>

<style lang="scss" scoped>
@mixin menu {
    background-color: transparent;
    border-right: 0;
}

.sider-menu {
    @include menu;
    padding-left: 10px;
    padding-right: 0;
    &::v-deep {
        .el-menu {
            @include menu;
        }
        .el-menu--popup {
            padding: 0;
            background-color: #001529 !important;
            .el-menu-item:last-child {
                margin-bottom: 0;
            }
        }
        .el-menu-item {
            height: 60px;
            line-height: 60px;
            font-size: 18px;
            font-weight: 400;
            &.is-active {
                background: #fff !important;
            }
        }
        .el-submenu__title {
            height: 40px;
            line-height: 40px;
            margin-bottom: 8px;
            padding-left: 35px !important;
            font-size: 16px;
            font-weight: 400;

        }
        .el-submenu {
            .el-menu-item {
                padding-left: 80px !important;
            }
        }

        .iconfont {
            display: inline-block;
            width: 30px;
        }
        .icon-school,
        .icon-question,
        .icon-logger {
            font-size: 18px;
        }
    }
}
</style>
